import { render, staticRenderFns } from "./SaleTypeCalendarSettingsEditItem.vue?vue&type=template&id=36cd7028&scoped=true"
import script from "./SaleTypeCalendarSettingsEditItem.vue?vue&type=script&lang=ts"
export * from "./SaleTypeCalendarSettingsEditItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd7028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36cd7028')) {
      api.createRecord('36cd7028', component.options)
    } else {
      api.reload('36cd7028', component.options)
    }
    module.hot.accept("./SaleTypeCalendarSettingsEditItem.vue?vue&type=template&id=36cd7028&scoped=true", function () {
      api.rerender('36cd7028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeCalendarSettingsEditItem.vue"
export default component.exports